import {Grid, Slot, Text, Trail, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {useBinaryState} from '@yandex-delivery/hooks'
import type {ReactElement} from 'react'

import {Body, PhoneInput, TextInput, ToggleTitle} from '../../../../components/desktop'
import {SwitchControlled} from '../Controlled/Switch'
import {useContact} from './Contact.hooks'
import type {Props} from './Contact.types'
import * as classes from './Contact@desktop.classes'

export function ContactDetails(props: Props): ReactElement {
  const i18n = useI18n()
  const [isOpen, _open, _close, toggle] = useBinaryState()
  const {isSource, labelPhone, labelName, names, smsTitle, smsSubtitle} = useContact(props)

  return (
    <Body
      className={classes.root}
      lead={
        <>
          <Typography group="tight" thickness="medium" variant="body2">
            {isSource
              ? i18n('cargo.create.form.source', 'Отправитель')
              : i18n('cargo.create.destinations.recipient', 'Получатель')}
          </Typography>
          <ToggleTitle isOpened={isOpen} onClick={toggle} title={i18n('cargo.create.address.details', 'Детали')} />
        </>
      }
      tail={
        <Grid container>
          <Grid xs={12} item>
            <PhoneInput label={labelPhone} name={names.phone} />
          </Grid>
          {isOpen && (
            <Grid xs={12} item>
              <Grid size="s" container>
                <Grid xs={12} item>
                  <TextInput label={labelName} name={names.name} size="l" variant="line" />
                </Grid>
                <Grid xs={12} item>
                  <Slot>
                    <Text style={{padding: 0}}>
                      <Typography variant="body2">{smsTitle}</Typography>
                      <Typography color="minor" variant="caption1">
                        {smsSubtitle}
                      </Typography>
                    </Text>
                    <Trail>
                      <SwitchControlled name={names.sms} />
                    </Trail>
                  </Slot>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      }
    />
  )
}
